import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, LockIcon, ZapIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-32 bg-black relative overflow-hidden" data-id="element-119">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[400px] bg-yellow-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-120" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-121">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-black uppercase tracking-tight text-white mb-8 leading-tight" data-id="element-122">
          ¿Hasta Cuándo Vas a Seguir <br className="hidden md:block" data-id="element-123" />
          <span className="text-yellow-500" data-id="element-124">
            Perdiendo tus Fines de Semana?
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl md:text-2xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-125">
          Cada domingo que planificás desde cero es tiempo que le quitás a tu
          descanso, tu familia y tu bienestar. <br data-id="element-126" />
          <br data-id="element-127" />
          <span className="text-white font-bold" data-id="element-128">
            Este sistema te devuelve ese tiempo. Hoy. Desde el primer uso.
          </span>
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={scrollToPricing} className="group relative inline-flex items-center justify-center gap-3 bg-yellow-500 text-black font-black uppercase px-8 py-5 md:px-12 md:py-6 rounded-full text-xl shadow-[0_0_40px_rgba(234,179,8,0.3)] hover:shadow-[0_0_60px_rgba(234,179,8,0.5)] transition-all w-full md:w-auto" data-id="element-129">
          SÍ, QUIERO MI SISTEMA AHORA
          <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-130" />
        </motion.button>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-wrap justify-center items-center gap-6 md:gap-10 mt-12 text-sm text-gray-400" data-id="element-131">
          <div className="flex items-center gap-2" data-id="element-132">
            <LockIcon className="w-5 h-5 text-gray-500" data-id="element-133" /> Pago Seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-134">
            <ZapIcon className="w-5 h-5 text-yellow-500" data-id="element-135" /> Acceso Inmediato
          </div>
          <div className="flex items-center gap-2" data-id="element-136">
            <MailIcon className="w-5 h-5 text-gray-500" data-id="element-137" /> PDF por Email
          </div>
          <div className="flex items-center gap-2" data-id="element-138">
            <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-139" /> Garantía 7
            días
          </div>
        </motion.div>
      </div>
    </section>;
}